import "@hey-api/client-fetch";
import { StageId } from "../../shared/api/types.gen.js";
var CommonStageIdEnum = /* @__PURE__ */ ((CommonStageIdEnum2) => {
  CommonStageIdEnum2["ERROR"] = "show_error";
  CommonStageIdEnum2["SUCCESS"] = "show_results";
  return CommonStageIdEnum2;
})(CommonStageIdEnum || {});
const StageEntityId = {
  ...StageId,
  ...CommonStageIdEnum
};
export {
  CommonStageIdEnum,
  StageEntityId
};
